import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bannerDataSelector } from "../../Redux/appStateSlice";
import { isExternalLink } from "../../utils";
import { Countdown } from "./Countdown";

export const HeaderBanner = () => {
  const history = useHistory();

  const { activeBanner } = useTimedBanners();

  if (!activeBanner) return null;

  const countdownUntil = activeBanner.countdownUntil || activeBanner.bannerEndTime;
  const shouldShowCountdown = activeBanner.shouldShowCountdown ?? true;
  const bannerText = activeBanner.bannerText;
  const linkTo = activeBanner.linkTo || null;

  const showBannerText = bannerText?.length > 0;

  // Allow hex colors to override
  const bannerBgStyle = activeBanner.bannerColor ? { backgroundColor: activeBanner.bannerColor } : {};
  const textStyle = activeBanner.textColor ? { color: activeBanner.textColor } : {};

  const handleBannerClick = () => {
    if (!linkTo) return;

    if (isExternalLink(linkTo)) {
      window.open(linkTo, "_blank", "noopener,noreferrer");
    } else {
      history.push(linkTo);
    }
  };

  return (
    <Container
      fluid
      className={`header-banner ${linkTo ? "cursor-pointer" : ""} ${activeBanner.bannerColor ? "" : "bg-dark"}`}
      style={{ minHeight: "50px", ...bannerBgStyle }}
      onClick={linkTo ? handleBannerClick : undefined}
      data-testid="header-banner"
    >
      <Container>
        <Row className={`banner-row ${activeBanner.textColor ? "" : "text-white"}`}>
          {showBannerText && (
            <div className="flex-center text-center" style={textStyle}>
              {bannerText}
            </div>
          )}
          {shouldShowCountdown && <Countdown countdownUntil={countdownUntil} style={textStyle} />}
        </Row>
      </Container>
    </Container>
  );
};

export const useTimedBanners = () => {
  const banners = useSelector(bannerDataSelector);

  // Calculate on first render
  const getCurrentBanner = () => {
    if (!banners || banners.length === 0) return null;

    const now = Date.now();
    return (
      banners.find((banner) => {
        const start = new Date(banner.bannerStartTime).getTime();
        const end = new Date(banner.bannerEndTime).getTime();
        return start <= now && end > now;
      }) || null
    );
  };

  const [activeBanner, setActiveBanner] = useState(getCurrentBanner);

  useEffect(() => {
    if (!banners || banners.length === 0) {
      setActiveBanner(null);
      return;
    }

    const checkBanner = () => {
      const current = getCurrentBanner();
      setActiveBanner(current);
    };

    checkBanner();

    const interval = setInterval(checkBanner, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banners]);

  return { activeBanner };
};
